import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 获取UploadKey列表
export const getUploadKeyList = (params) => { return req("get", "/api/getUploadKeyList", params) };
export const genNewUploadKeys = (params) => { return req("post", "/api/genNewUploadKeys", params) };
export const updateKeyStatus = (params) => { return req("put", "/api/updateUploadKeyStatus", params) };
export const deleteUploadKey = (params) => { return req("delete", "/api/deleteUploadKey", params) };



// WEBPACK FOOTER //
// ./src/api/keyMG.js